import { render, staticRenderFns } from "./uf_list_priority_products_formed_mvk_id.vue?vue&type=template&id=31de06bb&scoped=true"
import script from "./uf_list_priority_products_formed_mvk_id.vue?vue&type=script&lang=js"
export * from "./uf_list_priority_products_formed_mvk_id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de06bb",
  null
  
)

export default component.exports